export const EmployeeRewardWelfareVI = {
    "EmployeeRewardWelfareTitle": {
        "date" : "Ngày hưởng ",
        "benefitName" : "Tên phúc lợi",
        "money" : "Số tiền ",
        "moneyNumber" : "1,000,000",
        "form" : "Hình thức ",
        "paid" : "Đã thanh toán ",
        "paidOk" : "Phúc lợi này đã được thanh toán cho nhân viên ",
        "calculateSalary" : "Tính vào lương",
        "payroll" : "Phúc lợi này sẽ được công trực tiếp vào bảng lương "
    },
    "NotificationEmployeeRewardWelfare": {
        "edit": "Sửa dữ liệu thành công...",
        "add": "Thêm dữ liệu thành công...",
        "delete": "Xóa dữ liệu thành công...",
    }
}